<template>
    <v-card-actions class="pa-3">
        <v-layout row class="wrap-desktop-only">
            
            <v-flex 
                xs12 
                sm7 
                :class="['layout row align-center', isMobile ? 'mobile-icon-row-scroll' : 'wrap']"
            >
                <!-- Loop through all available reaction types -->
                <v-btn 
                    v-for="reaction in reactionTypes" 
                    :key="reaction.id"
                    icon 
                    :small="isMobile"
                    :class="['mx-1 flex-shrink-0', { 'active-reaction-btn': currentReactionId === reaction.id }]"
                    :title="reaction.title"
                    @click="handleReactionClick(reaction.id)"
                >
                    <v-icon :color="currentReactionId === reaction.id ? reaction.color : 'grey'">
                        {{ reaction.icon }}
                    </v-icon>
                </v-btn>
            </v-flex>

            <v-flex 
                xs12 
                sm5 
                :class="[
                    'layout row wrap my-1', 
                    isMobile ? 'justify-start mt-2' : 'justify-end align-center'
                ]"
            >
                <!-- Quick summary chips showing reaction totals -->
                <template v-for="summary in summaryData">
                    <v-chip 
                        v-if="summary.count > 0"
                        :key="'summary-' + summary.id"
                        class="ma-1 custom-reaction-chip" 
                        small
                        outline
                        :style="{ borderColor: getReactionColor(summary.id) }"
                        :class="{ 'active-chip-bg': currentReactionId === summary.id }"
                    >
                        <v-icon left small :color="getReactionColor(summary.id)">
                            {{ getReactionIconName(summary.id) }}
                        </v-icon>
                        <span :style="{ color: getReactionColor(summary.id) }" class="font-weight-bold">
                            {{ summary.count }}
                        </span>
                    </v-chip>
                </template>
            </v-flex>

        </v-layout>
    </v-card-actions>
</template>

<script>
import { REACTION_TYPES, getReactionType } from '@/helpers/reaction-types'

export default {
    name: 'UseReactions',
    props: {
        // Pass the initial reaction ID of the logged-in user if they already reacted (null if none)
        initialReactionId: {
            type: [Number, String],
            default: null
        },
        // Pass the calculated total reaction summary array from your API
        // Format: [{ id: 1, count: 12 }, { id: 2, count: 4 }]
        summaryData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            reactionTypes: REACTION_TYPES,
            currentReactionId: null
        }
    },
    watch: {
        initialReactionId: {
            immediate: true,
            handler(newVal) {
                this.currentReactionId = newVal ? parseInt(newVal) : null
            }
        }
    },
    methods: {
        handleReactionClick(reactionTypeId) {
            let action = 'add'
            let selectedId = reactionTypeId

            // Toggle mechanism: if clicking the exact same reaction, remove it
            if (this.currentReactionId === reactionTypeId) {
                this.currentReactionId = null
                selectedId = null
                action = 'remove'
            } else {
                this.currentReactionId = reactionTypeId;
                action = 'add'
            }

            // Emit payload back to parent view component
            this.$emit('send', {
                reactionTypeId: selectedId, // Returns numeric ID, or null if removed
                action: action,             // String tracking state: 'add' or 'remove'
                reactionDetails: selectedId ? getReactionType(selectedId) : null
            })
        },
        getReactionIconName(id) {
            const r = getReactionType(id)
            return r ? r.icon : ''
        },
        getReactionColor(id) {
            const r = getReactionType(id)
            return r ? r.color : 'grey'
        }
    }
};
</script>

<style scoped>
.active-reaction-btn {
    background-color: rgba(0, 0, 0, 0.05) !important;
    transform: scale(1.1);
    transition: transform 0.2s ease-in-out;
}
/* Forces buttons to maintain their size instead of squeezing together */
.flex-shrink-0 {
    flex-shrink: 0 !important;
}

/* Formats the row into a clean horizontal scroll track on mobile screens */
.mobile-icon-row-scroll {
    display: flex !important;
    flex-flow: row nowrap !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
}

/* Keeps desktop layout behaving normally while allowing mobile columns to stack */
@media (max-width: 600px) {
    .wrap-desktop-only {
        flex-direction: column !important;
        display: block !important;
    }
}

/* Clean up scrollbar visual clutter */
.mobile-icon-row-scroll::-webkit-scrollbar {
    display: none;
}

.active-reaction-btn {
    background-color: rgba(0, 0, 0, 0.05) !important;
    transform: scale(1.1);
    transition: transform 0.2s ease-in-out;
}

.custom-reaction-chip {
    border: 1px solid !important;
}

.active-chip-bg {
    background-color: rgba(0, 0, 0, 0.05) !important;
}
</style>
